import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import Home from "../views/home.vue";
import NotFound from "@/views/error/404.vue";
import Geschiedenis from "@/views/geschiedenis.vue";
import Praesidium from "@/views/praesidium.vue";
/**import OG from "@/views/og.vue";**/
import Clublied from "@/views/clublied.vue";
import Kalender from "@/views/kalender.vue";


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: Home
    },

    {
        path: "/geschiedenis",
        name: "Geschiedenis",
        component: Geschiedenis
    },

    {
        path: "/praesidium/:currentPraesidiumYear?",
        name: "Praesidium",
        component: Praesidium,
        props: true
    },
/**
    {
        path: "/og",
        name: "OG",
        component: OG
    },
*/
    {
        path: "/clublied",
        name: "Clublied",
        component: Clublied
    },

    {
        path: "/kalender",
        name: "Kalender",
        component: Kalender
    },

    /**
     * Default Fallback: 404 page.
     */
    {
        path: "*",
        component: NotFound
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
